import { CommonStateType, DispatchType, StateType } from "@/common/types";
import Types from "../types";
import { FrxTheme } from "@/common/constant";

export const toggleTheme = () => {
  return async (dispatch: DispatchType, getState: () => StateType) => {
    const { theme } = getState().common;
    const darkModePreference: boolean = theme === "light";
    const themePreference: CommonStateType["theme"] = darkModePreference
      ? "dark"
      : "light";
    dispatch({
      type: Types.SET_THEME,
      payload: themePreference,
    });
    window.localStorage.setItem(FrxTheme, themePreference);
    document.documentElement.classList.toggle("dark", darkModePreference);
  };
};

export const setLoader = (payload: boolean) => {
  return async (dispatch: DispatchType) => {
    dispatch({
      type: Types.SET_LOADER,
      payload,
    });
  };
};
